import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    },
    {
        path: '',
        loadChildren: () => import('./ovoc/ovoc.module').then(m => m.OVOCModule),
    },
    {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
                preloadingStrategy: PreloadAllModules,
            },
        ) // , {enableTracing: true}) // <-- debugging purposes only)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
